<div class="modal-header">
    <h5 class="modal-title">{{ 'formWorkflowSettings.title' | t }}</h5>
</div>
<div class="container-fluid">
    <div class="workflow-actions">
        <button class="btn btn-cerrix me-2" (click)="newDefinition()">
            <i class="fas fa-plus-circle"></i>
            <span class="d-none d-lg-inline">{{ 'formWorkflowSettings.addDefinitionBtn' | t }}</span>
        </button>
        <select class="custom-select" [(ngModel)]="focusedDefinition">
            @for (def of definitions; track def; let defIndex = $index) {
                <option [value]="defIndex">
                    {{ def.Name }}
                </option>
            }
        </select>
    </div>
    <hr />
    @for (def of definitions; track def; let defIndex = $index) {
        <div [hidden]="defIndex != focusedDefinition">
            @if (definitions.length > 1) {
                <i class="fas fa-trash workflow-delete" (click)="deleteDefinition()"></i>
            }
            <div class="form-group">
                <label for="form-groups">{{ 'formWorkflowSettings.definitionNameLabel' | t }}</label>
                <cerrix-textfield [(ngModel)]="def.Name" cssClass="form-control">
                </cerrix-textfield>
            </div>
            <div class="form-group">
                <label for="form-groups">{{ 'formWorkflowSettings.dataOwnerGroupsLabel' | t }}</label>
                <ng-select
                    [(ngModel)]="def.DefinitionDataOwners"
                    id="form-groups"
                    [items]="groups"
                    bindValue="ID"
                    bindLabel="Name"
                    [closeOnSelect]="false"
                    [multiple]="true"
                >
                </ng-select>
                <small class="text-muted">{{ 'formWorkflowSettings.dataOwnerGroupsInfo' | t }}</small>
            </div>
            <mat-accordion multi="true">
                @for (pageDef of def.PageDefinitions; track pageDef; let pageIndex = $index) {
                    <mat-expansion-panel
                        [class.section-start]="pageIndex > 0 && !pageDef.LinkedToPrevious"
                    >
                        <mat-expansion-panel-header
                            [class.bg-highlight]="form.Pages[pageIndex].Type === 2"
                        >
                            <mat-panel-title>
                                {{ 'formWorkflowSettings.pageTitle' | t: { number: pageIndex + 1, title: pageDef.Page.Title } }}
                            </mat-panel-title>
                            <mat-panel-description>
                                {{
                                    'formWorkflowSettings.pageType' | t
                                        : { type: pageDef.Page.Type === pageType.Entry ? "entry" : "review" }
                                }}
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        @if (
                            pageIndex > 0 &&
                            pageDef.Page.Type === 1 &&
                            form.Pages[pageIndex - 1].Type === 1 &&
                            !pageDef.LinkedToStarter &&
                            (!pageDef.Groups || pageDef.Groups.length === 0)
                        ) {
                            <div>
                                <mat-checkbox
                                    color="primary"
                                    [(ngModel)]="pageDef.LinkedToPrevious"
                                >
                                    {{ 'formWorkflowSettings.linkToPrevious' | t }}
                                </mat-checkbox>
                                <br />
                                <small>{{ 'formWorkflowSettings.linkToPreviousInfo' | t }}</small>
                                <br />
                            </div>
                        }
                        @if (
                            pageIndex !== 0 &&
                            pageDef.Page.Type === 1 &&
                            !pageDef.LinkedToPrevious &&
                            (!pageDef.Groups || pageDef.Groups.length === 0)
                        ) {
                            <div>
                                <mat-checkbox color="primary" [(ngModel)]="pageDef.LinkedToStarter">
                                    {{ 'formWorkflowSettings.sameAsEntryStarter' | t }}
                                </mat-checkbox>
                                <br />
                                <small>{{ 'formWorkflowSettings.sameAsEntryStarterInfo' | t }}</small>
                                <br />
                            </div>
                        }
                        @if (!pageDef.LinkedToStarter && !pageDef.LinkedToPrevious) {
                            <div class="form-group">
                                <label for="form-groups">{{ 'formWorkflowSettings.groupsLabel' | t }}</label>
                                <ng-select
                                    [(ngModel)]="pageDef.Groups"
                                    id="form-groups"
                                    [items]="groups"
                                    [multiple]="true"
                                    bindValue="ID"
                                    bindLabel="Name"
                                    [closeOnSelect]="false"
                                    (change)="setGroup(pageDef, $event)"
                                >
                                </ng-select>
                                @if (groups && groups.length === 0) {
                                    <div
                                        class="alert alert-danger small-alert system-required"
                                        role="alert"
                                    >
                                        {{ 'formWorkflowSettings.noUserGroupsFound' | t }}
                                    </div>
                                }
                                <small>{{ 'formWorkflowSettings.groupsInfo' | t }}</small>
                            </div>
                        }
                    </mat-expansion-panel>
                }
            </mat-accordion>
        </div>
    }
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="onSaveChanges()">{{ 'formWorkflowSettings.applyChangesBtn' | t }}</button>
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ 'formWorkflowSettings.cancelBtn' | t }}</button>
</div>
